<template>
    <div class="af3-shortcodes-single-main-component">

        <!-- Go Back Link -->
        <div class="af3-shortcodes-single-go-back-link" v-if="options.single_floor_plan_show_go_back_button">
            <a v-if="options.single_floor_plan_go_back_button_link" 
               :href="options.single_floor_plan_go_back_button_link" 
               class="af3-go-back-link">
                {{ options.single_floor_plan_go_back_button_text }}
            </a>
            <a v-else 
               @click.prevent="goBack" 
               class="af3-go-back-link af3-go-back-link-button">
                {{ options.single_floor_plan_go_back_button_text }}
            </a>
        </div>

        <div class="af3-shortcodes-floor-plan-page-main-component-tabs" v-if="options.single_floor_plan_show_vr_tours || options.single_floor_plan_show_fees || options.single_floor_plan_show_site_map">
            <button :class="activeTab === 'floor-plan-details' ? 'active' : ''" @click="handleTabChange('floor-plan-details')">Details</button>
            <button v-if="options.single_floor_plan_show_site_map" :class="activeTab === 'site-map' ? 'active' : ''" @click="handleTabChange('site-map')">Site Map</button>
            <button v-if="options.single_floor_plan_show_vr_tours && floor_plan.virtual_tour_url" :class="activeTab === 'vr-tours' ? 'active' : ''" @click="handleTabChange('vr-tours')">{{ options.single_floor_plan_vr_tours_tab_label || 'VR Tours' }}</button>
            <button v-if="options.single_floor_plan_show_fees" :class="activeTab === 'fees' ? 'active' : ''" @click="handleTabChange('fees')">Fees</button>
        </div>


       

        <single-detail-component
            v-if="activeTab === 'floor-plan-details'"
            :options="options"
            :floor_plan="floor_plan"
        ></single-detail-component>


        <single-map-component
            v-if="activeTab === 'site-map'"
            :options="options"
            :floor_plan="floor_plan"
            :selected_unit_name="selectedUnitName"
        ></single-map-component>
        

        <single-vr-component
            v-if="activeTab === 'vr-tours'"
            :options="options"
            :floor_plan="floor_plan"
        ></single-vr-component>

        <single-fees-component
            v-if="activeTab === 'fees'"
            :options="options"
            :floor_plan="floor_plan"
            :property_fees="property_fees"
        ></single-fees-component>


        <single-units-component
            v-if="floor_plan.available_units && options.single_floor_plan_show_units"
            :options="options"
            :floor_plan="floor_plan"
            :available_units="floor_plan.available_units"
            @select-unit="handleSelectUnit"
        ></single-units-component>

        <single-related-component
            v-if="options.single_floor_plan_show_related"
            :options="options"
            :floor_plan="floor_plan"
        ></single-related-component>


    </div>
</template>
  
<script>

import { defineComponent, ref, watch, onMounted, reactive  } from 'vue';
import SingleDetailComponent from './SingleDetailComponent.vue';
import SingleVrComponent from './SingleVrComponent.vue';
import SingleFeesComponent from './SingleFeesComponent.vue';
import SingleUnitsComponent from './SingleUnitsComponent.vue';
import SingleRelatedComponent from './SingleRelatedComponent.vue';
import SingleMapComponent from './SingleMapComponent.vue';

export default defineComponent({
    components: { SingleDetailComponent, SingleVrComponent, SingleFeesComponent, SingleUnitsComponent, SingleRelatedComponent, SingleMapComponent },
   
    props: {
        options: {
            type: Object,
            required: true
        },
        floor_plan: {
            type: Object,
            required: true
        },
        property_fees: {
            type: Array,
            required: true
        }
    },

    setup(props) {

        const activeTab = ref('floor-plan-details');

        onMounted(() => {
            document.querySelector('.af3-shortcode-floor-plan-single').classList.add('loaded');
            setTimeout(() => {
                document.querySelector('.af3-shortcodes-single-main-component').classList.add('loaded');
            }, 100);
        });

        const selectedUnitName = ref(null);

        const handleTabChange = (tab) => {
            activeTab.value = tab;
        };

        const handleSelectUnit = (unitName) => {
            selectedUnitName.value = unitName;
            if (props.options.single_floor_plan_show_site_map) {
                activeTab.value = 'site-map';
            }
        };

        const goBack = () => {
            window.history.back();
        };

         
    return {
        activeTab,
        handleTabChange,
        handleSelectUnit,
        selectedUnitName,
        goBack
    };
  },


  
  
});
</script>